import React, { useState, useEffect } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import DialogTitle from '@material-ui/core/DialogTitle'
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'
import { AiOutlineLoading, AiOutlineSave } from 'react-icons/ai'
import { Formik, Field, getIn, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ErrorPopUp from '../Shared/ErrorPopUp'
import { toastr } from 'react-redux-toastr'
import { userSmsService } from '../../_services/userSms.service'
import { BiMessageAltDetail } from 'react-icons/bi'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const SendMessageToUnitUser = props => {
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(props.open)

  useEffect(() => {
    setOpen(props.open)
  }, [props.open])

  const handleCloseModal = () => {
    setOpen(false)
  }

  const handleSubmit = (values, setSubmitting) => {
    setLoading(true)
    let dto = {}
    dto['toUserType'] = props.toUserType
    dto['text'] = values.text
    console.log(JSON.stringify(dto))

    userSmsService
      .addUserSmsByUserType(JSON.stringify(dto))
      .then(res => {
        toastr.success('پیام جدید با موفقیت ارسال شد')
        setLoading(false)
        handleCloseModal()
        setSubmitting(false)
      })
      .catch(error => {
        // console.log(error);
        setLoading(false)
        setSubmitting(false)
        toastr.error('مشکلی پیش آمد. لطفا دوباره سعی کنید.')
      })
  }

  const ValidationSchema = Yup.object().shape({
    text: Yup.string()
      .nullable()
      .trim()
      .required('متن پیام')
  })

  return (
    <React.Fragment>
      <a
        onClick={() => setOpen(true)}
        className="btn btn-sm btn-primary pull-left"
        style={{ margin: 0, marginLeft: 5 }}
        disabled={loading}>
        <BiMessageAltDetail size="20px" style={{ verticalAlign: 'middle' }} />
        &nbsp; اطلاع‌رسانی به مدیر پرس
      </a>
      <Dialog
        open={open}
        onClose={() => handleCloseModal()}
        TransitionComponent={Transition}
        scroll={'paper'}
        // fullScreen={true}
        fullWidth={true}
        maxWidth="sm">
        <DialogTitle>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
            <div>
              <Fab
                color="secondary"
                aria-label="refresh"
                size="small"
                onClick={() => handleCloseModal()}
                className="modal-close-btn">
                <MdClose size="20px" />
              </Fab>
              <span style={{ marginRight: 10 }}>اطلاع‌رسانی به مدیر پرس</span>
            </div>
          </div>
        </DialogTitle>
        <DialogContent dividers={true} className="modal-gray-bg">
          <Formik
            enableReinitialize
            initialValues={{
              text:
                '*گروه مصیبی*\nسفارشات جدید به پنل تولید شما ارجاع شده است. لطفا در اسرع وقت بررسی نمایید.\nباتشکر'
            }}
            onSubmit={(values, { setSubmitting }) => {
              // // console.log(values);
              handleSubmit(values, setSubmitting)
            }}
            validationSchema={ValidationSchema}>
            {props => {
              const {
                values,
                touched,
                errors,
                isSubmitting,
                handleChange,
                handleBlur,
                setFieldValue,
                handleSubmit
              } = props
              return (
                <form onSubmit={handleSubmit}>
                  <div className="row" style={{ position: 'relative' }}>
                    <div className="col-md-12 message-details-modal">
                      <fieldset className="fieldset">
                        <legend>ارسال پیام جدید</legend>

                        <div className="row">
                          <div className="form-inline">
                            <div className="col-md-12">
                              <label>متن پیام</label>
                              <Field
                                name="text"
                                rows="12"
                                render={({ field }) => (
                                  <textarea
                                    {...field}
                                    value={values.text}
                                    className={
                                      getIn(touched, 'text')
                                        ? getIn(errors, 'text')
                                          ? 'textarea rtl has-error'
                                          : 'textarea rtl'
                                        : 'textarea rtl has-error'
                                    }
                                  />
                                )}
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="text"
                              />
                            </div>

                            <div className="col-md-12">
                              <br />
                              <button
                                type="submit"
                                className={
                                  'icon button submit-btn ' +
                                  (isSubmitting ? 'isSubmitting' : '')
                                }
                                disabled={isSubmitting}
                                onClick={e => {
                                  e.preventDefault()
                                  handleSubmit()
                                }}>
                                {isSubmitting ? (
                                  <AiOutlineLoading
                                    className="mdi-spin"
                                    size="22px"
                                  />
                                ) : (
                                  <AiOutlineSave size="22px" />
                                )}
                                ذخیره
                              </button>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </form>
              )
            }}
          </Formik>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  )
}

export default SendMessageToUnitUser
